import { render, staticRenderFns } from "./ForEmployersLogoSection.vue?vue&type=template&id=b609f6d8&"
import script from "./ForEmployersLogoSection.vue?vue&type=script&lang=js&"
export * from "./ForEmployersLogoSection.vue?vue&type=script&lang=js&"
import style0 from "./ForEmployersLogoSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports